import React from 'react';
import { Collapse } from '@mui/material';

import {
  Typography,
  Paper,
  Switches,
  TextField,
  CardContent,
  CardHeader,
} from '@occc-app/design-system';

import copies from './copies';
import { TriggerOnOfferVisibilityChangeProps } from './types';

const TriggerOnOfferVisibilityChange: React.FC<TriggerOnOfferVisibilityChangeProps> = ({
  open,
}) => {
  const { title, description } = copies;

  return (
    <Paper>
      <CardHeader
        title={
          <Typography variant='h6' component='p' gutterBottom>
            {title}
          </Typography>
        }
        subheader={<Typography color='textSecondary'>{description}</Typography>}
        action={<Switches name='triggerPreferences.triggerOnVisibility' data={{}} />}
      />
      <Collapse in={open} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <TextField name='marketingContent.triggeredMessageContent.visibilitySms' />
        </CardContent>
      </Collapse>
    </Paper>
  );
};

export default TriggerOnOfferVisibilityChange;
